<!-- <app-base [templateRef]=''></app-base>-->
<style type="text/css">
  [data-aos] {
    opacity: 1 !important;
    transform: translate(0) scale(1) !important;
  }
</style>

<body id="top">
  <header class="bg-light">

    <div class="page-content" style="margin-bottom: 10px;">
      <div id="content">
        <header>
          <div class="cover bg-light" style="background: linear-gradient(180deg ,  #91bdf8, #F5F7FA  );">
            <div class="container px-3">
              <div class="row">
                <div class="col-lg-6 p-4 pt-0" align="center">
                  <div class="mt-4"><img class="img-fluid" src="/assets/images/hello.jpg" width="340" height="auto"
                      alt="hello" style="border-radius: 50%" /></div>
                </div>
                <div class="col-lg-6">
                  <div class="mt-5">
                    <p class="lead text-uppercase mb-1">Hello!</p>
                    <h1 class="intro-title marker" data-aos="fade-left" data-aos-delay="20">I’m Anas CHARFI</h1>
                    <p class="lead fw-normal mt-3" data-aos="fade-up" data-aos-delay="100">
                      'ERP-BI' Engineering Student "Last grade"
                      <br>
                      Freelance Developer & Data Scientist
                    </p>
                    <div class="social-nav" data-aos="fade-up" data-aos-delay="200">
                      <nav role="navigation">
                        <ul class="nav justify-content-left">
                          <li class="nav-item"><a class="nav-link" href="https://twitter.com/CharfiAnas"
                              title="Twitter"><i class="fab fa-twitter"></i><span
                                class="menu-title sr-only">Twitter</span></a></li>
                          <li class="nav-item"><a class="nav-link" href="https://www.facebook.com/The.Hakerz.Zinger/"
                              title="Facebook"><i class="fab fa-facebook-f"></i><span
                                class="menu-title sr-only">Facebook</span></a></li>
                          <li class="nav-item"><a class="nav-link" href="https://www.instagram.com/anascharfi/"
                              title="Instagram"><i class="fab fa-instagram"></i><span
                                class="menu-title sr-only">Instagram</span></a></li>
                          <li class="nav-item"><a class="nav-link" href="https://www.linkedin.com/in/anas-charfi/"
                              title="LinkedIn"><i class="fab fa-linkedin"></i><span
                                class="menu-title sr-only">LinkedIn</span></a></li>
                          <li class="nav-item"><a class="nav-link" href="https://github.com/AnasCharfi"
                              title="Behance"><i class="fab fa-github"></i><span
                                class="menu-title sr-only">Behance</span></a></li>
                        </ul>
                      </nav>
                    </div>
                    <div class="mt-3" data-aos="fade-up" data-aos-delay="200"><a
                        class="btn btn-primary shadow-sm mt-1 hover-effect" href="#contact">Get In Touch <i
                          class="fas fa-arrow-right"></i></a></div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </header>

      </div>
    </div>
  </header>

  <!-- CV FORMAT Begins HERE-->
  <div class="page-content" id="about">
    <div class="container">
      <div class="cover shadow-lg bg-white">
        <div class="cover-bg p-3 p-lg-4 text-white">
          <div class="row">
            <div class="col-lg-4 col-md-5">
              <div class="avatar hover-effect bg-white shadow-sm p-1"><img style="filter: grayscale(40%)!important;" src="/assets/2nd/images/Anas_CHARFI.jpeg" width="200"
                  height="200" /></div>
            </div>
            <div class="col-lg-8 col-md-7 text-center text-md-start">
              <h2 class="h1 mt-2" data-aos="fade-left" data-aos-delay="0">Anas CHARFI</h2>
              <p data-aos="fade-left" data-aos-delay="100">Developer & Data Scientist</p>
              <div class="d-print-none" data-aos="fade-left" data-aos-delay="200"><a
                  class="btn btn-light text-dark shadow-sm mt-1 me-1" href="assets/CV_Anas-CHARFI.pdf"
                  target="_blank">Download
                  CV</a><a class="btn btn-success shadow-sm mt-1" href="#contact">Hire
                  Me</a></div>
            </div>
          </div>
        </div>
        <div class="about-section pt-4 px-3 px-lg-4 mt-1">
          <div class="row">
            <div class="col-md-6">
              <h2 class="h3 mb-3">About Me</h2>
              <p style="text-align: justify; text-justify: inter-word;">Hello there! Welcome to my Resume, I am Anas a
                self-directed and driven Business Intelligence last grade Engineering student.
                Enthusiast developer and self-learner.
                Digital Marketing and Java Trainer.
              </p>
            </div>
            <div class="col-md-5 offset-md-1"
              style="border: solid rgba(128, 128, 128, 0.527) 1px; border-radius: 10px;">
              <div class="row mt-2">
                <div class="col-sm-4">
                  <div class="pb-1">Age</div>
                </div>
                <div class="col-sm-8">
                  <div class="pb-1 text-secondary">23</div>
                </div>
                <div class="col-sm-4">
                  <div class="pb-1">Email</div>
                </div>
                <div class="col-sm-8">
                  <div class="pb-1 text-secondary">
                    <a style="color:#656d78"
                      href="mailto:charfianas1@gmail.com?subject=Website Contact&body=Hello Anas [from your website],">CharfiAnas1@gmail.com</a>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="pb-1">Phone/Whatsapp</div>
                </div>
                <div class="col-sm-8">
                  <div class="pb-1 text-secondary">
                    <a style="color:#656d78"
                      href="https://api.whatsapp.com/send?phone=21653072794&text=Hello from Anas Charfi website!">+216-53-072-794</a>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="pb-1">Address</div>
                </div>
                <div class="col-sm-7">
                  <div class="pb-1 text-secondary">
                    <ul>
                      <li style="color:#4A89DC;">
                        <p style="color: #656D78;">Ksar Hellal, Monastir</p>
                      </li>
                      <li style="color:#37BC9B;">
                        <p style="color: #656D78;">Ariana Soghra, Tunis</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr class="d-print-none" id="skills" />
        <div class="skills-section px-3 px-lg-4">
          <h2 class="h3 mb-3">Professional Skills</h2>
          <div class="row">
            <div class="col-md-6">
              <div class="mb-2"><span>Python</span>
                <div class="progress my-1">
                  <div class="progress-bar bg-primary" role="progressbar" data-aos="zoom-in-right" data-aos-delay="100"
                    data-aos-anchor=".skills-section" style="width: 90%" aria-valuenow="90" aria-valuemin="0"
                    aria-valuemax="100"></div>
                </div>
              </div>
              <div class="mb-2"><span>Spring Framework/Java</span>
                <div class="progress my-1">
                  <div class="progress-bar bg-primary" role="progressbar" data-aos="zoom-in-right" data-aos-delay="200"
                    data-aos-anchor=".skills-section" style="width: 85%" aria-valuenow="85" aria-valuemin="0"
                    aria-valuemax="100"></div>
                </div>
              </div>
              <div class="mb-2"><span>SQL</span>
                <div class="progress my-1">
                  <div class="progress-bar bg-primary" role="progressbar" data-aos="zoom-in-right" data-aos-delay="200"
                    data-aos-anchor=".skills-section" style="width: 85%" aria-valuenow="85" aria-valuemin="0"
                    aria-valuemax="100"></div>
                </div>
              </div>
              <div class="mb-2"><span>Angular</span>
                <div class="progress my-1">
                  <div class="progress-bar bg-primary" role="progressbar" data-aos="zoom-in-right" data-aos-delay="300"
                    data-aos-anchor=".skills-section" style="width: 75%" aria-valuenow="75" aria-valuemin="0"
                    aria-valuemax="100"></div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-2"><span>Power BI</span>
                <div class="progress my-1">
                  <div class="progress-bar bg-success" role="progressbar" data-aos="zoom-in-right" data-aos-delay="400"
                    data-aos-anchor=".skills-section" style="width: 90%" aria-valuenow="90" aria-valuemin="0"
                    aria-valuemax="100"></div>
                </div>
              </div>
              <div class="mb-2"><span>Scikit-learn / Keras / Tensor Flow</span>
                <div class="progress my-1">
                  <div class="progress-bar bg-success" role="progressbar" data-aos="zoom-in-right" data-aos-delay="500"
                    data-aos-anchor=".skills-section" style="width: 85%" aria-valuenow="85" aria-valuemin="0"
                    aria-valuemax="100"></div>
                </div>
              </div>
              <div class="mb-2"><span>R Language</span>
                <div class="progress my-1">
                  <div class="progress-bar bg-success" role="progressbar" data-aos="zoom-in-right" data-aos-delay="600"
                    data-aos-anchor=".skills-section" style="width: 90%" aria-valuenow="75" aria-valuemin="0"
                    aria-valuemax="100"></div>
                </div>
              </div>
              <div class="mb-2"><span>CRISP-DM</span>
                <div class="progress my-1">
                  <div class="progress-bar bg-success" role="progressbar" data-aos="zoom-in-right" data-aos-delay="600"
                    data-aos-anchor=".skills-section" style="width: 90%" aria-valuenow="75" aria-valuemin="0"
                    aria-valuemax="100"></div>
                </div>
              </div>
            </div>
          </div>
          <hr>
          <div class="row">
            <div class="col-md-6">
              <div class="mb-2"><span>Git</span>
                <div class="progress my-1">
                  <div class="progress-bar bg-primary" role="progressbar" data-aos="zoom-in-right" data-aos-delay="100"
                    data-aos-anchor=".skills-section" style="width: 90%" aria-valuenow="90" aria-valuemin="0"
                    aria-valuemax="100"></div>
                </div>
              </div>
              <div class="mb-2"><span>Agile SCRUM</span>
                <div class="progress my-1">
                  <div class="progress-bar bg-primary" role="progressbar" data-aos="zoom-in-right" data-aos-delay="200"
                    data-aos-anchor=".skills-section" style="width: 85%" aria-valuenow="85" aria-valuemin="0"
                    aria-valuemax="100"></div>
                </div>
              </div>
              <div class="mb-2"><span>Digital Marketing</span>
                <div class="progress my-1">
                  <div class="progress-bar bg-primary" role="progressbar" data-aos="zoom-in-right" data-aos-delay="300"
                    data-aos-anchor=".skills-section" style="width: 75%" aria-valuenow="75" aria-valuemin="0"
                    aria-valuemax="100"></div>
                </div>
              </div>
              <div class="mb-2"><span>Adobe Photoshop / Illustrator</span>
                <div class="progress my-1">
                  <div class="progress-bar bg-primary" role="progressbar" data-aos="zoom-in-right" data-aos-delay="300"
                    data-aos-anchor=".skills-section" style="width: 95%" aria-valuenow="75" aria-valuemin="0"
                    aria-valuemax="100"></div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-2"><span>Arabic</span>
                <div class="progress my-1">
                  <div class="progress-bar bg-success" role="progressbar" data-aos="zoom-in-right" data-aos-delay="400"
                    data-aos-anchor=".skills-section" style="width: 100%" aria-valuenow="100" aria-valuemin="0"
                    aria-valuemax="100"></div>
                </div>
              </div>
              <div class="mb-2"><span>English</span>
                <div class="progress my-1">
                  <div class="progress-bar bg-success" role="progressbar" data-aos="zoom-in-right" data-aos-delay="500"
                    data-aos-anchor=".skills-section" style="width: 90%" aria-valuenow="90" aria-valuemin="0"
                    aria-valuemax="100"></div>
                </div>
              </div>
              <div class="mb-2"><span>French</span>
                <div class="progress my-1">
                  <div class="progress-bar bg-success" role="progressbar" data-aos="zoom-in-right" data-aos-delay="600"
                    data-aos-anchor=".skills-section" style="width: 85%" aria-valuenow="85" aria-valuemin="0"
                    aria-valuemax="100"></div>
                </div>
              </div>
              <div class="mb-2"><span>German</span>
                <div class="progress my-1">
                  <div class="progress-bar bg-success" role="progressbar" data-aos="zoom-in-right" data-aos-delay="600"
                    data-aos-anchor=".skills-section" style="width: 20%" aria-valuenow="20" aria-valuemin="0"
                    aria-valuemax="100"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr class="d-print-none" id="experience" />
        <div class="work-experience-section px-3 px-lg-4">
          <h2 class="h3 mb-4">Work Experience</h2>
          <div class="timeline">
            <div class="timeline-card timeline-card-primary card shadow-sm">
              <div class="card-body">
                <div class="h5 mb-1">Internship - Fullstack Developer <span class="text-muted h6">at Quality of Services
                    Design `QoS Design`</span></div>
                <div class="text-muted text-small mb-2">1 Aug, 2021 - 15 Sept, 2021 [6 weeks]</div>
                <div style="text-align: justify; text-justify: inter-word;">Short experience along with Two supervisors
                  and one team mate was just phenomenal,
                  it was an opportunity for me to improve my french communication skills. Besides, the internship topic
                  focused on the study, design and
                  development of a prototype of a web application allowing the intelligent collection and analysis of
                  promotional offers published on social networks.
                  Given the health situation related to Covid-19, the internship was conducted remotely with regular
                  supervision and follow-up of the trainee.
                </div>
                <div class="text-muted text-small mb-2"><b>Key words:</b> Python, Flask, SQL,
                  Angular, NodeJS, Sentiment Analysis, RestAPI, Web Scraping, Open Source Tools, Postman, Team Work.
                </div>
              </div>
            </div>
            <div class="timeline-card timeline-card-primary card shadow-sm">
              <div class="card-body">
                <div class="h5 mb-1">Internship - Junior Data Scientist <span class="text-muted h6">at Digital Research
                    & Technologies `DRT`</span></div>
                <div class="text-muted text-small mb-2">Feb, 2020 - Jul, 2020 [6 months]</div>
                <div style="text-align: justify; text-justify: inter-word;">The journey in this company was incredibly
                  beneficial for me as I improved my Communication & Technical Skills & Project Management & Team Work,
                  it was for my Graduation Project to get my licence, the project was
                  an Automatic Platform for the Analysis of Social Media.
                </div>
                <div class="text-muted text-small mb-2"><b>Key words:</b> SCRUM, Python, NumPy, Pandas, Flask, MongoDB,
                  Angular, NodeJS,
                  Sentiment Analysis, Statistics, Charts, RestAPI, Web Scraping, Team Work.</div>
              </div>
            </div>
          </div>
        </div>
        <hr class="d-print-none" />
        <div class="page-break"></div>
        <div class="education-section px-3 px-lg-4 pb-4">
          <h2 class="h3 mb-4">Education</h2>
          <div class="timeline">
            <div class="timeline-card timeline-card-success card shadow-sm">
              <div class="card-body">
                <div class="h5 mb-1">2nd grade Computer Science Engineering <span
                    style="font-size: 70%">[</span>specialized in Business Intelligence 'BI'<span
                    style="font-size: 70%">]</span> Student <span class="text-muted h6">at
                    Esprit University, Ariana, Tunisia</span></div>
                <div class="text-muted text-small mb-2">2021 - 2022</div>
                <div style="text-align: justify; text-justify: inter-word;">
                  After getting a licence in CS, I felt that it wasn't enough knowledge for me to really get in the
                  professional world,
                  so I find out that the best choice is the continous within my studies, and after one year I'm sure
                  that it was the Best
                  Choice for me, getting courses at Esprit is really pumping my brain with more and more knowledge and
                  experiences. </div>
              </div>
            </div>
            <div class="timeline-card timeline-card-success card shadow-sm">
              <div class="card-body">
                <div class="h5 mb-1">Fundamental Licence in Computer Science <span class="text-muted h6">from Higher
                    Institute of C.S of Mahdia, Tunisia</span></div>
                <div class="text-muted text-small mb-2">2017 - 2020</div>
                <div style="text-align: justify; text-justify: inter-word;">
                  At this stage in my life and as a technology enthusiastic, it was a future vision for me till my High
                  to study CS; 3 years at this institute was just Amazing, I felt that it was the place where I really
                  should be, I've learned a lot of technologies, Problem Solving and Concepts such as <b>Algorithm</b>,
                  <b>UML</b>, <b>JAVA</b>, <b>JAVA Swing</b>, <b>Android</b>, <b>Basic Web
                    Developement</b>[HTML,CSS,JavaScript,Bootstrap,...], <b>Computer Network</b>[CCNA], <b>Artificial
                    Intelligence</b> and more.
                </div>
              </div>
            </div>
            <div class="timeline-card timeline-card-success card shadow-sm">
              <div class="card-body">
                <div class="h5 mb-1">Baccalaureate in Technical Sciences <span class="text-muted h6">from 2 March High
                    School, Ksar Hellal, Monastir</span>
                </div>
                <div class="text-muted text-small mb-2">2017</div>
                <div style="text-align: justify; text-justify: inter-word;">
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr class="d-print-none" />
        <div class="page-break"></div>
        <div class="education-section px-3 px-lg-4 pb-4">
          <h2 class="h3 mb-4">Projects Realized</h2>
          <div class="timeline">
            <div class="timeline-card timeline-card-success card shadow-sm">
              <div class="card-body">
                <div class="h5 mb-1">
                  Desktop application for the management and control of stores
                  <span class="text-muted h6">for Amazon LLC</span>
                </div>
                <div class="text-muted text-small mb-2">2021</div>
                <div style="text-align: justify; text-justify: inter-word;">
                  This tool was developed for an Amazon Store in Germany, a detailed description was given at first
                  where my client specified every task the software was supposed to do, and it was for the stores
                  employees where everyone of them could track the packages that he's supposed to work on or deliver for
                  trucks
                  that delivers them to Amazons clients; also a control feature to track Time and Calculate for the
                  employee
                  how much packages he delivered, supposed to deliver and wait to treat,
                  and Finally, Advanced Filtering with low run time is primordial feature in stores at the scale of
                  Amazon ones.
                  <br>
                  An executable file was delivered and a Training on how to Install and
                  Personalize this software (colors, screen resolution, table columns size,...)
                </div>
                <div class="text-muted text-small mb-2"><b>Key words:</b> Python, Getting Data From Amazon Servers,
                  Numpy, Pandas, Tkinter, Selenium.</div>
                <div class="text-muted text-small mb-2"><a routerLink="../portfolio" fragment="Logistics_Company">more
                    info</a></div>
              </div>

            </div>
            <div class="timeline-card timeline-card-success card shadow-sm">
              <div class="card-body">
                <div class="h5 mb-1">Decision support web platform for investment
                  <span class="text-muted h6"></span>
                </div>
                <div class="text-muted text-small mb-2">2021</div>
                <div style="text-align: justify; text-justify: inter-word;">

                </div>
                <div class="text-muted text-small mb-2"><b>Key words:</b> ML, RNN, LSTM, TensorFlow 2.x, Keras, Python,
                  Flask, MongoDB, Angular, SpringBoot, Statistics, Charts (collecte, analyse, prévision et visualisation
                  des données), Team Work</div>

                <div class="text-muted text-small mb-2"><a routerLink="../portfolio" fragment="trency">more info</a>
                </div>
              </div>

            </div>
            <div class="timeline-card timeline-card-success card shadow-sm">
              <div class="card-body">
                <div class="h5 mb-1">Management of private sports fields
                  <span class="text-muted h6">as an Academic Project</span>
                  <span class="text-muted h6"></span>
                </div>
                <div class="text-muted text-small mb-2">2021</div>
                <div style="text-align: justify; text-justify: inter-word;">
                  A project was done by 6 team members, the module I've done within this project was 'Field Management',
                  where I had
                  4 entities, Category (Field sport, Number of team members in a game, Period of game,...), Field (Name,
                  Adress, Lat, Lon, #category,...),
                  Calendar (that must be created automaticly with the creation of the Field) and Finally Reservation
                  (Time, Date, #idField, #idPlayer,...).
                </div>
                <div class="text-muted text-small mb-2"><b>Key words:</b> SCRUM, SQL, Java, JavaFX, CodeNameOne, Symfony
                  4.4,
                  Web, Desktop, Mobile, DB Centralized, Team Work, Github, Google Maps, FullCalendar, Mailing API.</div>
                <div class="text-muted text-small mb-2"><a routerLink="../portfolio" fragment="Terrainet">more info</a>
                </div>
              </div>

            </div>

          </div>
        </div>
        <hr class="d-print-none" />
        <div class="contant-section px-3 px-lg-4 pb-4" id="volunteer">
          <div class="row">

            <h2 class="h3 mb-3">Volunteer experiences</h2>

            <p style="text-align: justify; text-justify: inter-word;">
              As I believe that <i>"The world will not be destroyed by those who do evil, but by those who watch them
                without doing anything."</i><u> -Albert Einstein</u> I'm always trying to be engaged within
              organisations that their main objectives are sharing knowledge and make the world a better place.</p>

          </div>



          <hr class="d-print-none" />
          <div class="row">
            <h2 class="h5" align='center'>Google Developers Group Monastir</h2>
            <div class="">
              <IMG src="/assets/images/logos/logo_gdg.png" ALIGN="left" HSPACE="50" width="188" height="39" />
              <p style="text-align: justify; text-justify: inter-word;">Google Developer Groups (GDGs) are for
                developers
                who are interested in Google's, Open Source and other Companies Technologies; everything from the
                Android,
                Chrome, Drive, and Google Cloud platforms, to product APIs like the Cast API, Maps API, and YouTube API.

                A GDG can take many forms -- from just a few people getting together to watch our latest video, to large
                gatherings
                with demos and tech talks, to events like code sprints and hackathons. However, at the core, GDGs are
                focused on developers and technical content, and the core audience should be developers. 'Google LLC'.
              </p>
            </div>


            <div class="">
              <div class="row mt-2">

                <div class="col-sm-2" align="center">
                  <div class="pb-1">
                    <div class="pb-1 text-secondary"></div>
                  </div>
                </div>


                <div class="col-sm-2" align="center">
                  <div class="pb-1 text-secondary" style="margin-bottom: 0pt;">Position</div>
                  <div class="pb-1" style="margin-top: 0pt;">Organizer</div>
                </div>

                <div class="col-sm-2" align="center">
                  <div class="pb-1 text-secondary" style="margin-bottom: 0pt;">From</div>
                  <div class="pb-1" style="margin-top: 0pt;">Jan 2021</div>
                </div>

                <div class="col-sm-2" align="center">
                  <div class="pb-1 text-secondary" style="margin-bottom: 0pt;">To</div>
                  <div class="pb-1" style="margin-top: 0pt;">Now</div>
                </div>

                <div class="col-sm-2" align="center">
                  <div class="pb-1 text-secondary" style="margin-bottom: 0pt;">Period</div>
                  <div class="pb-1" style="margin-top: 0pt;">{{dateDiff("Jan 01 2021")}}</div>
                </div>

                <div class="col-sm-2" align="center">
                  <div class="pb-1">
                    <div class="pb-1 text-secondary"></div>
                  </div>
                </div>
              </div>
            </div>
            <hr class="d-print-none" />

          </div>

          <div class="row">
            <h2 class="h5" align='center'>Google Developers Students Club Esprit University</h2>
            <div class="">
              <IMG src="/assets/images/logos/dsc_esprit_logo.png" ALIGN="left" HSPACE="50" width="185" height="81" />
              <p style="text-align: justify; text-justify: inter-word;">My job is Performing market research,
                Analyzing social media metrics and try to observe patterns of behavior,
                Connecting user behavior with a viable marketing strategy,
                Liaising with the marketing team to brainstorm a marketing campaign,
                Keeping abreast of social media trends.
              </p>
            </div>


            <div class="">
              <div class="row mt-2">

                <div class="col-sm-2" align="center">
                  <div class="pb-1">
                    <div class="pb-1 text-secondary"></div>
                  </div>
                </div>


                <div class="col-sm-2" align="center">
                  <div class="pb-1 text-secondary" style="margin-bottom: 0pt;">Position</div>
                  <div class="pb-1" style="margin-top: 0pt;">Marketing Stratigist</div>
                </div>

                <div class="col-sm-2" align="center">
                  <div class="pb-1 text-secondary" style="margin-bottom: 0pt;">From</div>
                  <div class="pb-1" style="margin-top: 0pt;">Sep 2020</div>
                </div>

                <div class="col-sm-2" align="center">
                  <div class="pb-1 text-secondary" style="margin-bottom: 0pt;">To</div>
                  <div class="pb-1" style="margin-top: 0pt;">Now</div>
                </div>

                <div class="col-sm-2" align="center">
                  <div class="pb-1 text-secondary" style="margin-bottom: 0pt;">Period</div>
                  <div class="pb-1" style="margin-top: 0pt;">{{dateDiff("Sep 01 2020")}}</div>
                </div>

                <div class="col-sm-2" align="center">
                  <div class="pb-1">
                    <div class="pb-1 text-secondary"></div>
                  </div>
                </div>
              </div>
            </div>
            <hr class="d-print-none" />

          </div>

          <div class="row">
            <h2 class="h5" align='center'>Google Developers Students Club Mahdia</h2>
            <div class="">
              <IMG src="/assets/images/logos/logo_dsc.png" ALIGN="left" HSPACE="50" width="175" height="110" />
              <p style="text-align: justify; text-justify: inter-word;">After being the Founder and Leader of
                this initiative provided by Google LLC, my superiors honored me to be a Mentor for another year.
              </p>
            </div>


            <div class="">
              <div class="row mt-2">

                <div class="col-sm-2" align="center">
                  <div class="pb-1">
                    <div class="pb-1 text-secondary"></div>
                  </div>
                </div>


                <div class="col-sm-2" align="center">
                  <div class="pb-1 text-secondary" style="margin-bottom: 0pt;">Position</div>
                  <div class="pb-1" style="margin-top: 0pt;"><b>Mentor</b></div>
                </div>

                <div class="col-sm-2" align="center">
                  <div class="pb-1 text-secondary" style="margin-bottom: 0pt;">From</div>
                  <div class="pb-1" style="margin-top: 0pt;">Aug 2020</div>
                </div>

                <div class="col-sm-2" align="center">
                  <div class="pb-1 text-secondary" style="margin-bottom: 0pt;">To</div>
                  <div class="pb-1" style="margin-top: 0pt;">Sept 2021</div>
                </div>

                <div class="col-sm-2" align="center">
                  <div class="pb-1 text-secondary" style="margin-bottom: 0pt;">Period</div>
                  <div class="pb-1" style="margin-top: 0pt;">1 Year, 1 Month</div>
                </div>

                <div class="col-sm-2" align="center">
                  <div class="pb-1">
                    <div class="pb-1 text-secondary"></div>
                  </div>
                </div>
              </div>
            </div>
            <hr class="d-print-none" />

          </div>


          <div class="row">
            <h2 class="h5" align='center'>Google Developers Students Club Mahdia</h2>
            <div class="">
              <IMG src="/assets/images/logos/logo_dsc.png" ALIGN="left" HSPACE="50" width="175" height="110" />
              <p style="text-align: justify; text-justify: inter-word;">DSC is a program powered by Google where
                DevTechs are our
                First concern to study and train other students on.
              </p>
            </div>


            <div class="">
              <div class="row mt-2">

                <div class="col-sm-2" align="center">
                  <div class="pb-1">
                    <div class="pb-1 text-secondary"></div>
                  </div>
                </div>


                <div class="col-sm-2" align="center">
                  <div class="pb-1 text-secondary" style="margin-bottom: 0pt;">Position</div>
                  <div class="pb-1" style="margin-top: 0pt;">Founder & Leader</div>
                </div>

                <div class="col-sm-2" align="center">
                  <div class="pb-1 text-secondary" style="margin-bottom: 0pt;">From</div>
                  <div class="pb-1" style="margin-top: 0pt;">Oct 2019</div>
                </div>

                <div class="col-sm-2" align="center">
                  <div class="pb-1 text-secondary" style="margin-bottom: 0pt;">To</div>
                  <div class="pb-1" style="margin-top: 0pt;">Aug 2020</div>
                </div>

                <div class="col-sm-2" align="center">
                  <div class="pb-1 text-secondary" style="margin-bottom: 0pt;">Period</div>
                  <div class="pb-1" style="margin-top: 0pt;">9 Months</div>
                </div>

                <div class="col-sm-2" align="center">
                  <div class="pb-1">
                    <div class="pb-1 text-secondary"></div>
                  </div>
                </div>
              </div>
            </div>
            <hr class="d-print-none" />

          </div>

          <div class="row">
            <h2 class="h5" align='center'>ISIMa Google Club</h2>
            <div class="">
              <IMG src="/assets/images/logos/isima_google_club_logo.png" ALIGN="left" HSPACE="50" width="173"
                height="98" />
              <p style="text-align: justify; text-justify: inter-word;">Hello there! I am passionate about Developement
                and Data Science.
                Web and Desktop developer with some skills in Data Science and Graphic Design tools such as Photoshop.
              </p>
            </div>


            <div class="" style="margin-bottom:0%">
              <div class="row mt-2" style="margin-bottom:0%">

                <div class="col-sm-2" align="center">
                  <div class="pb-1">
                    <div class="pb-1 text-secondary"></div>
                  </div>
                </div>


                <div class="col-sm-2" align="center">
                  <div class="pb-1 text-secondary" style="margin-bottom: 0pt;">Position</div>
                  <div class="pb-1" style="margin-top: 0pt;">President</div>
                </div>

                <div class="col-sm-2" align="center">
                  <div class="pb-1 text-secondary" style="margin-bottom: 0pt;">From</div>
                  <div class="pb-1" style="margin-top: 0pt;">Aug 2018</div>
                </div>

                <div class="col-sm-2" align="center">
                  <div class="pb-1 text-secondary" style="margin-bottom: 0pt;">To</div>
                  <div class="pb-1" style="margin-top: 0pt;">Jan 2020</div>
                </div>

                <div class="col-sm-2" align="center">
                  <div class="pb-1 text-secondary" style="margin-bottom: 0pt;">Period</div>
                  <div class="pb-1" style="margin-top: 0pt;">1 Year, 4 Months</div>
                </div>

                <div class="col-sm-2" align="center">
                  <div class="pb-1">
                    <div class="pb-1 text-secondary"></div>
                  </div>
                </div>
              </div>
            </div>


          </div>





        </div>
        <hr class="d-print-none" />
        <div class="contant-section px-3 px-lg-4 pb-4 mb-4" id="contact">
          <h2 class="h3 text mb-3">Contact</h2>
          <div class="row">
            <div class="col-md-7 d-print-none">
              <div class="my-2">
                <form action="https://formspree.io/f/mrgrakjk" method="POST" name="formspree">
                  <div class="row">
                    <div class="col-6">
                      <input class="form-control" type="text" id="name" name="name" placeholder="Your Name" required>
                    </div>
                    <div class="col-6">
                      <input class="form-control" type="email" id="email" name="_replyto" placeholder="Your E-mail"
                        required>
                    </div>
                  </div>
                  <div class="form-group my-2">
                    <textarea class="form-control" style="resize: none;" id="message" name="message" rows="4"
                      placeholder="Your Message" required></textarea>
                  </div>
                  <button class="btn btn-primary mt-2" type="submit">Send</button>
                </form>
              </div>
            </div>
            <div class="col">
              <div class="mt-2">
                <h3 class="h6">Address</h3>
                <div class="pb-2 text-secondary">
                  <ul style="margin-bottom: 0;">
                    <li>Ksar Hellal, Monastir</li>
                    <li>Ariana Soghra, Tunis</li>
                  </ul>
                </div>
                <h3 class="h6">Phone / Whatsapp</h3>
                <div class="pb-2 text-secondary">
                  <a style="color:#656d78"
                    href="https://api.whatsapp.com/send?phone=21653072794&text=Hello from Anas Charfi website!">+216-53-072-794</a>
                </div>
                <h3 class="h6">Email</h3>
                <div class="pb-2 text-secondary">
                  <a style="color:#656d78"
                    href="mailto:charfianas1@gmail.com?subject=Website Contact&body=Hello Anas [from your website],">CharfiAnas1@gmail.com</a>
                </div>
              </div>
            </div>

            <!-- CV FORMAT Ends HERE-->
          </div>
        </div>
      </div>
    </div>
  </div>


  <script src="/assets/2nd/scripts/bootstrap.bundle.min.js?ver=1.2.0"></script>
  <script src="/assets/2nd/scripts/aos.js?ver=1.2.0"></script>
  <script src="/assets/2nd/scripts/main.js?ver=1.2.0"></script>
  <script src="/assets/scripts/imagesloaded.pkgd.min.js?ver=1.1.0"></script>
  <script src="/assets/scripts/masonry.pkgd.min.js?ver=1.1.0"></script>
  <script src="/assets/scripts/bootstrap.bundle.min.js?ver=1.1.0"></script>
  <script src="/assets/scripts/aos.js?ver=1.1.0"></script>
  <script src="/assets/scripts/main.js?ver=1.1.0"></script>


</body>